import { render } from "./Select2IconSelectItem.vue?vue&type=template&id=4f0ba914&scoped=true"
import script from "./Select2IconSelectItem.vue?vue&type=script&lang=js"
export * from "./Select2IconSelectItem.vue?vue&type=script&lang=js"

import "./Select2IconSelectItem.vue?vue&type=style&index=0&id=4f0ba914&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f0ba914"]])

export default __exports__